export enum EDemandModalText {
  SEND = 'Отправить заявку риелтору',
  NEXT = 'Дальше',
}
